import { defineMessages } from 'react-intl';

export const paymentDetailsMessages = defineMessages({
  notes: {
    defaultMessage: 'Notes',
    id: 'Pg6lq/',
    description: 'Label for the notes field in the payment details section',
  },
});
